// token key
export const TOKEN_KEY = 'TOKEN__';

export const LOCALE_KEY = 'LOCALE__';

// user info key
export const USER_INFO_KEY = 'USER__INFO__';

// role info key
export const ROLES_KEY = 'ROLES__KEY__';

// dict info key
export const DB_DICT_DATA_KEY = 'UI_CACHE_DB_DICT_DATA';

// project config key
export const PROJ_CFG_KEY = 'PROJ__CFG__KEY__';

// lock info
export const LOCK_INFO_KEY = 'LOCK__INFO__KEY__';

export const MULTIPLE_TABS_KEY = 'MULTIPLE_TABS__KEY__';

export const APP_DARK_MODE_KEY_ = '__APP__DARK__MODE__';

// base global local key
export const APP_LOCAL_CACHE_KEY = 'COMMON__LOCAL__KEY__';

// base global session key
export const APP_SESSION_CACHE_KEY = 'COMMON__SESSION__KEY__';
// 租户 key
export const TENANT_ID = 'TENANT_ID';
// login info key
export const LOGIN_INFO_KEY = 'LOGIN__INFO__';
// weak password
export const WEAK_PASSWORD = 'USER_WEAK_PASSWORD';
export const USER_CONFIG_KEY = 'USER__CONFIG__';
export const SERVER_CONFIG_KEY = 'SERVER__CONFIG__';
export const FIELDS_COLUMNS_CONFIG_KEY = 'FIELDS__CONFIG__'
export const DRAWER_INFO_KEY = 'DRAWER__INFO__';
// 新功能提醒缓存键  若有新功能提醒 修改该值
export const NEW_FEATURE_NOTIFICATION_KEY = 'NEW__FEATURE__PROJECT__';
// 面板切换：表格和卡片样式切换
export const PANEL_TYPE_KEY = 'PANEL__TYPE__';
// 项目列表面板切换：表格和卡片样式切换
export const PROJECT_PANEL_TYPE_KEY = 'PROJECT__PANEL__TYPE__';
// 标注审核提示条关闭状态  退出登录时清除
export const ANNOTATION_REVIEW_HINT_KEY = 'ANNOTATION__REVIEW__HINT__';

export enum CacheTypeEnum {
  SESSION,
  LOCAL,
}
